import {NGXLogger} from 'ngx-logger';

export class AceLogger {

  private configEntryName: string;

  constructor(private logger: NGXLogger, configEntryName: string) {
    if (configEntryName !== undefined && configEntryName !== null) {
      this.configEntryName = configEntryName.toUpperCase();
    } else {
      this.configEntryName = '';
    }
  }

  public trace(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.trace, message, additional);
  }

  public debug(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.debug, message, additional);
  }

  public info(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.info, message, additional);
  }

  public log(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.log, message, additional);
  }

  public warn(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.warn, message, additional);
  }

  public error(message: any, ...additional: any[]): void {
    this.proxyLog(this.logger.error, message, additional);
  }

  private proxyLog(logFn: Function, message: any, additional: any[]) {
    const ad = (additional !== undefined && additional !== null) ? additional : [];

    if (message !== undefined && message !== null) {
      if (typeof message === 'string') {
        logFn.apply(this.logger, [this.getDecoratedMessage(message)].concat(ad));
      } else {
        logFn.apply(this.logger, [this.getDecoratedMessage(''), message].concat(ad));
      }
    } else {
      logFn.apply(this.logger, [this.getDecoratedMessage('')].concat(ad));
    }
  }

  private getDecoratedMessage(message: string): string {
    if (this.configEntryName) {
      return '[' + this.configEntryName + '] ' + message;
    } else {
      return message;
    }
  }
}
